'use client';

import { type FC } from 'react';
import { usePathname } from 'next/navigation';
import { LeftNavItem, type LeftNavItemProps } from '@/_components/LeftNavItem';
import { DeveloperNavProps } from './DeveloperNav.types';

export const DeveloperNav: FC<DeveloperNavProps> = ({ isHovering }) => {
  const path = usePathname();

  const items: Array<LeftNavItemProps> = [
    { isBackToWorkspace: true, isHovering },
    // { isSeparator: true, name: 'Developer' },
    {
      name: 'API Docs',
      icon: 'file-code',
      href: '/developer/api-docs',
      isActive: path.startsWith('/developer/api-docs'),
    } as LeftNavItemProps,
    {
      name: 'API Access',
      icon: 'code',
      isLocked: true,
      href: '/developer/api-access',
      isActive: path.startsWith('/developer/api-access'),
    } as LeftNavItemProps,
    {
      name: 'Webhooks',
      icon: 'webhooks',
      isLocked: true,
      href: '/developer/webhooks',
      isActive: path.startsWith('/developer/webhooks'),
    } as LeftNavItemProps,
    {
      name: 'Sandbox',
      icon: 'cube',
      isLocked: true,
      href: '/developer/sandbox',
      isActive: path.startsWith('/developer/sandbox'),
    } as LeftNavItemProps,
  ];

  return (
    <>
      {items.map((item, key) => (
        <LeftNavItem {...item} key={key} isActive={item.isActive} />
      ))}
    </>
  );
};
